module.exports = __webpack_public_path__ + "static/certificate1-18a69eb025a2cb6ba76a73365627a7c9.jpg";